import { render, staticRenderFns } from "./YourRequest.vue?vue&type=template&id=2fccf35a&scoped=true&"
import script from "./YourRequest.vue?vue&type=script&lang=js&"
export * from "./YourRequest.vue?vue&type=script&lang=js&"
import style0 from "./YourRequest.vue?vue&type=style&index=0&id=2fccf35a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fccf35a",
  null
  
)

export default component.exports